import AccessCodeService from "../../services/accessCodeService";

class UserTypeManager {
    static getUserType(): string | undefined {
        const storedType = localStorage.getItem('userCode');
        console.log('storedType:', storedType);
        if (!storedType) {
            return undefined;
        }
        return storedType;
    }

    static async setTypeFromCode(userCode: string): Promise<boolean> {
        const allCodes = await AccessCodeService.fetchCodes();
        const code = allCodes.find(code => code.code === userCode);
        if (!code) {
            console.error('Invalid code:', userCode);
            return false;
        } else {
            localStorage.setItem('userCode', code.code);
            return true;
        }
    }

    static clearUserType(): void {
        console.log('clearing user type');
        localStorage.removeItem('userCode');
    }

}

export default UserTypeManager;